import BrandMagnetScoreWarning from './brandMagnetScoreWarning'
export default BrandMagnetScoreWarning
